module.exports = __webpack_public_path__ + "img/ANTENNA WAVES BW.958101c.svg";